// extracted by mini-css-extract-plugin
export default {"wrapperDonate":"DonateInfoBlock_wrapperDonate__Ko9BT"};